const docTypeNames = ['DRE','Balanço Patrimonial','Balancete mais recente','Organograma da Composição do Grupo','Estatuto Contrato Social','Acordo de Acionistas dos Atuais Dirigentes']

export function getDocTypeName(docType: 0 | 1 | 2 | 3 | 4 | 5){
    return docTypeNames[docType];
}

export type FileFinepModel = { 
    docType:  0 | 1 | 2 | 3 | 4 | 5;
    fileAzurePath: string;
    fileName: string;
    id: string;
    isValid: boolean;
    pathName: string;
    registerId: string;
}

